module.exports = __webpack_public_path__ + "img/f.2eb27967.jpg";